import axios from 'axios'
import { useState } from 'react'
import { useAppContext } from '~/src/context/AppProvider'

const useSubmitNumber = () => {
  const { setPhoneSubmitted } = useAppContext()
  const [processing, setProcessing] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const submit = async (data: {
    hash?: string | null
    tempUserId?: string | null
    userNumber: string | number
    reason?: 'price' | 'issue'
  }) => {
    if (processing || submitted) return

    setError(null)
    setSubmitted(false)
    setProcessing(true)

    try {
      const resp = await axios.post('/api/contact', data)
      const respData = resp.data

      if (respData.success) {
        setSubmitted(true)
        setPhoneSubmitted(data.userNumber.toString())
      } else {
        setError('An error occurred. Please try again.')
      }
    } catch (_error: any) {
      setError('An error occurred. Please try again.')
    } finally {
      setProcessing(false)
    }
  }

  return {
    processing,
    submitted,
    submit,
    error,
  }
}

export default useSubmitNumber
